import React from "react";
import DeviceContext from "../../../../services/indentifyDevice";
import LoginPopup from "../../../login/generic/loginPopup";
import LoginForm, { VendorLoginFormProps } from "../Forms/LoginForm";
import NuvamaLogo from "../../../../assets/new_images/nuvama-logo.svg";

export interface VendorLoginScreenProps extends VendorLoginFormProps {
  onClose?: () => void;
}

const LoginScreen: React.FC<VendorLoginScreenProps> = (props) => {
  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={props.onClose}
      className="login_scrn"
    >
      <LoginForm {...props} />
    </LoginPopup>
  );
};

export default LoginScreen;
